import React from "react";
import { getWhatsappData } from "../../Action/courseAction";
import { WhatsappDataPage } from "../Common/whatsappCommon";

function WhatsappDataAnalysis() {
  return (
    <WhatsappDataPage
      pageTitle="WHATSAPP DATA ANALYSIS"
      tableId="whatsapp-data-analysis"
      fetchAction={getWhatsappData}
      examKey="examTypeId"
      nameKey="typeName"
      nameHeader="Source"
      exportName="WhatsApp Data Analysis"
    />
  );
}

export default WhatsappDataAnalysis;
